<template>
  <div
    class="w-full md:w-56 py-3 transition-shadow duration-300 ease-in-out rounded-lg shadow-md hover:shadow-xl"
    :class="{ 'opacity-50': !active }"
    :ref="`account-${account.id}-card`"
  >
    <div class="pl-3">
      <div
        class="flex items-center font-bold text-primary"
        :ref="`account-${account.id}-name`"
      >
        <input
          v-if="toggleEdit"
          v-model="newName"
          class="flex-initial inline-block min-w-0 font-bold border-0 outline-none text-primary"
          maxlength="20"
          :placeholder="account.name"
        >
        <p
          v-else
          class="truncate cursor-default"
        >
          {{ name ? name : account.name }}
        </p>
        <div class="self-center flex-grow flex-shrink-0 mx-2">
          <button
            v-if="toggleEdit"
            @click="saveChanges(active, newName)"
            class="p-1 rounded shadow-sc-button"
          >
            <img
              :src="require('@assets/images/done.svg')"
              width="16"
            >
          </button>
          <button
            v-else
            @click="toggleEdit = !toggleEdit"
            class="p-1 rounded hover:shadow-sc-button"
          >
            <img :src="require('@assets/images/edit.svg')">
          </button>
        </div>
        <b-switch
          size="is-small"
          v-model="toggleActive"
          @input="saveChanges(toggleActive, name)"
        />
      </div>
      <div
        v-if="account.loginRequired"
      >
        <b-tooltip
          type="is-danger"
          position="is-bottom"
        >
          <b-tag
            type="is-danger"
          >
            {{ $t('message.settings.accountsTab.reconnectAccount') }}
          </b-tag>
          <template v-slot:content>
            {{ $t('message.settings.accountsTab.reconnectAccountTooltip') }}
          </template>
        </b-tooltip>
      </div>
      <div
        class="pt-2"
      >
        <p
          class="text-xs font-normal leading-6 text-secondary"
        >
          {{ $t('message.settings.accountsTab.balance') }}
        </p>
        <p
          class="text-base font-semibold text-primary"
          :ref="`account-${account.id}-balance`"
        >
          {{ account.currentBalance | currency(account.currency) }}
        </p>
      </div>
      <div class="mt-3 border-t border-solid border-sc-gray-light" />
      <div class="flex items-start pt-4">
        <img :src="require('@assets/images/user.svg')">
        <div
          class="pl-2"
          :ref="`account-${account.id}-holder`"
        >
          <p
            class="text-xs font-normal leading-3 tracking-wide text-primary"
          >
            {{ account.holderName.split(" ").map((name) => name[0].toUpperCase() + name.slice(1)).join(' ') }}
          </p>
          <p
            class="pt-1 text-xs font-normal text-secondary"
          >
            {{ account.rut }}
          </p>
        </div>
      </div>
      <div class="flex items-start pt-4">
        <img :src="require('@assets/images/wallet.svg')">
        <div
          class="pl-2"
        >
          <p
            class="font-mono text-xs font-medium leading-4 text-primary"
          >
            {{ account.number }}
          </p>
          <p
            class="pt-1 text-xs font-normal leading-4 tracking-wide text-primary"
            :ref="`account-${account.id}-institution`"
          >
            {{ account.institutionName }}
          </p>
          <p
            class="pt-1 text-xs font-normal leading-4 tracking-wide text-secondary"
          >
            {{ account.name }}
          </p>
        </div>
      </div>
    </div>
    <div class="mt-4 border-t border-solid border-sc-gray-light" />
    <div
      class="flex pt-3 pl-3"
      :class="{'invisible': !account.fintocRefreshedAt}"
      :ref="`account-${account.id}-refresh`"
    >
      <img :src="require('@assets/images/time.svg')">
      <p
        class="pl-1 text-xs text-secondary"
      >
        Actualizada {{ account.fintocRefreshedAt | relativeTime }}
      </p>
    </div>
  </div>
</template>

<script>
import AccountApi from '../../api/bank-accounts.js';

export default {
  data() {
    return {
      name: this.account.customName,
      active: this.account.isActive,
      toggleEdit: false,
      newName: this.account.customName,
      toggleActive: this.account.isActive,
      errors: [],
    };
  },
  props: {
    account: {
      type: Object,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    activeAccounts: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    async saveChanges(active, content) {
      try {
        if (active !== this.active || content !== this.name) {
          await AccountApi.editAccount({ accountId: this.account.id, entityId: this.entityId,
            isActive: active, newName: content });
          if (active !== this.active) {
            this.$emit('edit', active);
          }
          if (content !== this.name) {
            this.toggleEdit = false;
          }
          this.active = active;
          this.name = content;
        }
      } catch (error) {
        this.errors.push(error);
      }
    },
  },
  computed: {
  },
};
</script>
